import type { Happening } from "./what-happened.ts";

export const EVERY_KIND = [
  "all",
  "releases",
  "messages",
  "mentions",
  "files",
  "calls",
  "apps",
  "agents",
  "people",
] as const;

export type OfAKind = (typeof EVERY_KIND)[number];

const HELD: Record<Exclude<OfAKind, "all" | "mentions">, readonly string[]> = {
  releases: ["deploy.finished", "deploy.failed", "deploy.skipped", "serve.set", "app.deployed"],
  messages: ["message.posted"],
  files: ["object.added"],
  calls: ["call.scheduled", "call.started", "call.joined", "call.left", "call.ended"],
  agents: [
    "agent.delegated",
    "agent.delegationReleased",
    "agent.reportedAnEnd",
    "agent.nudged",
    "agent.steered",
    "agent.defined",
    "run.started",
    "run.finished",
    "run.stopped",
    "run.did",
  ],
  apps: [
    "ship.set",
    "app.created",
    "app.placed",
    "app.unplaced",
    "app.repositoryAttached",
    "app.repositoryTokenSet",
    "app.secretKept",
    "app.secretForgotten",
    "app.environmentSet",
    "app.environmentRemoved",
    "app.runRecipeSet",
  ],
  people: [
    "conversation.created",
    "participant.added",
    "participant.removed",
    "labelled",
    "project.created",
    "project.joined",
    "account.created",
    "agent.created",
    "agent.edited",
  ],
};

export function isOfKind(happening: Happening, kind: OfAKind, me: string): boolean {
  if (kind === "all") return true;
  if (kind === "mentions") {
    const mentioned = happening.payload.mentioned;
    return Array.isArray(mentioned) && mentioned.some((one) => one === me);
  }
  return HELD[kind].includes(happening.kind);
}

export function matchesTheSearch(happening: Happening, line: string, looking: string): boolean {
  const wanted = looking.trim().toLowerCase();
  if (wanted === "") return true;
  const parts = [
    line,
    happening.preview ?? "",
    happening.by.name ?? "",
    happening.by.handle ?? "",
    happening.conversation?.title ?? "",
    happening.project?.name ?? "",
  ];
  return parts.some((part) => part.toLowerCase().includes(wanted));
}

export function theDayItHappened(at: string, now: Date): "today" | "yesterday" | string {
  const then = new Date(at);
  const day = (date: Date) => `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
  if (day(then) === day(now)) return "today";
  const before = new Date(now);
  before.setDate(before.getDate() - 1);
  if (day(then) === day(before)) return "yesterday";
  return day(then);
}
